<template>
  <el-main>
  
      <el-table
          ref="singleTable"
          :row-style="{height:'20px'}"
          :cell-style="{padding:'0px'}"
          :data="xmList"
          border
          highlight-current-row
          @current-change="handleCurrentChange"
          style="width: 100%">

          <el-table-column
        
            label="题组"
            width="150">
           <template slot-scope="scope">
            <i class="el-icon-s-operation"></i>
            <span style="margin-left: 10px">{{ scope.row.xmname }}</span>
          </template>

          </el-table-column>        

 

          <el-table-column
        
            label="总数"
            width="100">
           <template slot-scope="scope">
           
            <span style="margin-left: 10px">{{ scope.row.wancheng +scope.row.all }}</span>
          </template>

          </el-table-column>


          <el-table-column
        
            label="已评阅"
            width="100">
           <template slot-scope="scope">
      
            <span style="margin-left: 10px">{{ scope.row.wancheng }}</span>
          </template>

          </el-table-column> 

         <el-table-column
        
            label="未评阅"
            width="100">
           <template slot-scope="scope">
        
            <span style="margin-left: 10px">{{ scope.row.all }}</span>
          </template>

          </el-table-column> 


         <el-table-column
        
            label="完成比"
            width="200">
           <template slot-scope="scope">
             <el-progress :stroke-width="20" :text-inside="true" :percentage='(100*((scope.row.wancheng/(scope.row.wancheng +scope.row.all)).toFixed(4))).toFixed(2)'></el-progress>
          
          </template>

          </el-table-column>


        <el-table-column label="查看详情"
           width="100">
              <template slot-scope="scope">
              
              <el-button 
                  size="mini"
                  @click="handleSingleTizu(scope.$index, scope.row)">查看详情</el-button>
          
              </template>
          </el-table-column>
        </el-table>
  
   

  <el-dialog :title="title" :visible.sync="dialogTableVisible" :close-on-press-escape="false" :close-on-click-modal="false">
    <el-table 
       stripe
       border
       :default-sort = "{prop: 'yjschool', order: 'ascending'}"

      :row-style="{height:'20px'}"
      :cell-style="{padding:'0px'}"
      :data="singleTizuData">
        <el-table-column sortable property="yjschool" label="学校" width="150"></el-table-column>
        <el-table-column property="yjer" label="账号" width="150"></el-table-column>
        <el-table-column property="xm" label="姓名" width="100"></el-table-column>
        <el-table-column property="yjcount" label="阅卷数量" width="100"></el-table-column>
        <el-table-column property="junfen" label="平均分" width="100"></el-table-column>      
    </el-table>
  </el-dialog>

<div id="people">
  <v-client-table :data="tableData" :columns="columns" :options="options"/>
</div>

  </el-main>
  

</template>
<script>
import axios from 'axios'
import qs from 'qs'
export default {
  data() {
    return {
      		img_src:'',
          fit:'contain',
          xmList: [],
          singleTizuData:[],
          currentRow: null,
          status:false,
          title:'hello world',
          schoolList:[],
          selSchool:'',
          selClass:'',
          editableTabs: [
            {
                title: 'Tab 1',
                name: '1',
                content: 'Tab 1 content'
            }, 
            {
                  title: 'Tab 2',
                  name: '2',
                  content: 'Tab 2 content'
            }
            ],
            sel_xm:'',
            sel_sb:'',
            dialogTableVisible: false,
            
         };
  },
   activated() {
			console.log('单科进度查询页面');
			//阅卷题组信息
			this.sel_xm=this.$route.query.xm;
      this.sel_sb=this.$route.query.subject;
      this.xmList=[];
      this.handleDankeJinDu();

	},
  methods: {
    // 星号处理手机号
    noPassByMobile(str){
        if(null != str && str != undefined){
            var pat=/(\d{3})\d*(\d{4})/;
            return str.replace(pat,'$1****$2');
        } else {
            return "";
        }
    },

     // 星号处理名称
    noPassByName(str){
        if(null != str && str != undefined){
            if(str.length <= 3){
                return "*" + str.substring(1,str.length);
            } else if(str.length > 3 && str.length <= 6){
                return "**" + str.substring(2,str.length);
            } else if(str.length > 6){
                return str.substring(0,2) + "****" + str.substring(6,str.length)
            }
        } else {
            return "";
        }
      },

    handleDankeJinDu()
    {	
        axios.post('/score?op=yjKemuJinduAll',qs.stringify({"xm":this.sel_xm,"kemu":this.sel_sb})).then((res)=>{
              console.log(res)
              this.xmList=res.data;
              
          }).catch((res)=>{
              console.log(response)
          })      

    },
     

       handleSingleTizu(index, row) {
        
        this.singleTizuData=[];

        let tizu_enname=this.xmList[index]["enname"];
       
 
        this.title="题组--"+this.xmList[index]["xmname"]+' 阅卷详情';


         axios.post('/score?op=yjKemuJinduOneTizu',qs.stringify({"xm":this.sel_xm,"kemu":this.sel_sb,"tizuenname":tizu_enname})).then((res)=>{
                  console.log(res)  
                  let tmpData=res.data;
                  console.log(res.data.length);
                  let alen=res.data.length;
                  if (tmpData.length>=1)
                  {

                    for (let i = 0; i < tmpData.length; i++)
                     {                                              
                       tmpData[i]['yjer']=this.noPassByMobile(tmpData[i]['yjer']);
                       tmpData[i]['xm']=this.noPassByMobile(tmpData[i]['xm']);
                    }

                     for (let i = 0; i < tmpData.length; i++)
                     {                                              
                       tmpData[i]['yjer']=this.noPassByName(tmpData[i]['yjer']);
                       tmpData[i]['xm']=this.noPassByName(tmpData[i]['xm']);
                    }
                    
                  }

                  this.singleTizuData=tmpData;        
                  
              }).catch((res)=>{
             
              })
         this.status=false;
         this.dialogTableVisible = true;
  
      },


  },
}
</script>

<style scoped>
.el-dialog {
     display: flex;
     flex-direction: column;
     margin:0 !important;
     position:absolute;
     top:50%;
     left:50%;
     transform:translate(-50%,-50%);
     /*height:600px;*/
     max-height:calc(100% - 200px);
     max-width:calc(100% - 30px);
}
.el-dialog .el-dialog__body {
     flex:1;
     overflow: auto;
}

</style>